<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="flexBox">
      <text-title mainTitle="收款账户配置" subheading="" />
      <div>
        <a @click="save">保存</a>
        <a @click="cel">取消</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款账户：</span>
        </div>
        <el-select v-model="aliAccountName" size="small" style="width: 280px">
          <el-option v-for="item in collectionAccountList" :key="item.aliAccountName" :label="item.aliAccountName" :value="item.aliAccountName"> </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">支付宝账号：</span>
        </div>
        <el-input v-model="aliAccountNo" size="small" style="width: 280px" disabled />
      </div>
      <!--<div class="form-line">-->
      <!--<div class="textBox">-->
      <!--<b class="red">*</b>-->
      <!--<span class="line-text">设备名称：</span>-->
      <!--</div>-->
      <!--<el-input v-model="deviceName" size="small" style="width: 280px" />-->
      <!--</div>-->
    </form>
  </div>
</template>

<script>
import { nError, nSuccess } from '../../../utils/notice'
import { errorHandler } from '../../../utils/errorHandler'
import { pattern } from '../../../utils/regular'
import { api } from '../../api/ElectronicManagement'
import TextTitle from '../../../components/Text/TextTitle'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    Breadcrumb,
    TextTitle,
  },
  name: 'electronic-account-modify',
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: '智慧燃气',
            name: 'gas-over-view',
          },
          {
            value: '收款账户配置',
          },
        ],
      },
      maxlength: 32,
      collectionAccountList: [],
      aliAccountName: '',
      aliAccountNo: '',
      firstTime: true,
    }
  },
  created() {
    // this.getAccountList()
    // this.getFaceConfigData()
  },
  methods: {
    cel() {
      this.$router.push({
        name: 'electronic-account-center',
      })
    },
    getAccountList() {
      this.$axios
        .post(api.getAccountList, {})
        .then((res) => {
          let data = res.data.data
          this.collectionAccountList = data
          this.getAliAccount()
        })
        .catch(errorHandler('获取支付宝账户列表失败'))
    },
    getAliAccount() {
      this.$axios
        .get(api.getAliAccount, {})
        .then((res) => {
          let data = res.data.data
          this.aliAccountName = data.aliAccountName
          if (data) {
            this.firstTime = false
          } else {
            this.firstTime = true
          }
        })
        .catch(errorHandler('获取收款账户数据失败'))
    },
    save() {
      let obj = {}
      this.collectionAccountList.map((v) => {
        if (v.aliAccountName === this.aliAccountName) {
          obj = v
        }
      })
      if (this.firstTime) {
        this.$axios
          .post(api.addAliAccount, obj)
          .then((res) => {
            nSuccess('修改成功')
            this.cel()
          })
          .catch(errorHandler('修改失败'))
      } else {
        this.$axios
          .post(api.updateAliAccount, obj)
          .then((res) => {
            nSuccess('修改成功')
            this.cel()
          })
          .catch(errorHandler('修改失败'))
      }
    },
  },
  watch: {
    aliAccountName(val) {
      this.collectionAccountList.map((v) => {
        if (v.aliAccountName === val) {
          this.aliAccountNo = v.aliAccountNo
        }
      })
    },
  },
}
</script>

<style scoped>
.main_right {
  text-align: left;
}
.flexBox {
  display: flex;
  justify-content: space-between;
}

.flexBox a {
  line-height: 58px;
  margin-right: 40px;
  cursor: pointer;
  color: #00a0e6;
}
.flexBox a:hover {
  color: #06b3ff;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.main_right {
  .faceConfigTip {
    display: inline-block;
    min-width: 80px;
    text-align: right;
  }
  .faceConfigInput {
    display: inline-block;
    width: 313px;
    height: 28px;
    margin-left: 10px;
    .el-input__inner {
      height: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/GasManage/GasAccountConfig/GasAccountModify.vue